import {
  Button,
  Card,
  CardBody,
  Badge,
  Progress
} from "reactstrap";

import { 
  FaUsers
} from "react-icons/fa";
interface Props {
  onJoin: () => void;
  onLogin: () => void;
  onRegister: () => void;
  isAuthenticated: boolean;
   count: number;

}

const JoinCard = ({
  onJoin,
  onLogin,
  onRegister,
  isAuthenticated,
   count
}: Props) => {

   const totalCount = Math.max(count - 2, 0);
  const targetCount = 10;
   
    
return isAuthenticated ? (
  <Card className="border-0 shadow rounded-4" style={{ maxWidth: "1300px", width: "100%" }}>
    <CardBody className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 className="fw-bold mb-1">Live Group Status</h5>
          <small className="text-muted">
            Track the group's progress in real time
          </small>
        </div>

        <div
          className="bg-warning bg-opacity-25 rounded-circle d-flex align-items-center justify-content-center"
          style={{ width: 55, height: 55 }}
        >
          <FaUsers size={24} className="text-warning" />
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="fw-semibold">Group Progress</span>

        <Badge color="warning" pill className="px-3 py-2">
          {totalCount}/{targetCount}
        </Badge>
      </div>

      <Progress
        value={totalCount}
        max={targetCount}
        color="warning"
        style={{
          height: "12px",
          borderRadius: "10px",
        }}
      />

      <Button
        color="primary"
        size="lg"
        className="w-100 rounded-3 mt-4"
        onClick={onJoin}
      >
        Join This Group
      </Button>
    </CardBody>
  </Card>
) : null;
};

export default JoinCard;